module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gm-65c86e0a8df296521d901a6c76f801d8.svg";